import { useEffect } from 'react';

export enum MetricTypes {
  // 首帧播放耗时（s）
  firstFrameLoadTime = 'first_frame_load_time',
  // 当前播放资源地址
  videoUrl = 'video_url',
  // 视频总时长（s）
  videoDuration = 'video_duration',
  // 点赞状态
  likeStatus = 'like_status',
  // 收藏状态
  collectStatus = 'collect_status',
  // 评论状态
  commentStatus = 'comment_status',
  // 失败原因
  failReason = 'fail_reason',
  // 图片上传状态
  imageUploadStatus = 'image_upload_status',
  // 视频上传状态
  videoUploadStatus = 'video_upload_status',
}

export enum statusTypes {
  // 点击
  click = 1,
  // 成功
  success = 2,
  // 失败
  fail = 3,
  // 非错误导致的未成功(如: 未登录/未绑定手机号)
  unErrorFail = 4,
}

type SlsDataType = 'setEnvironment' | 'reportMetric' | 'reportNativeApi' | 'reportSentryError';
// reportMetric 的 key 是字符串 value 必须是number类型
export type SlsData = 
  | [Exclude<SlsDataType, 'reportMetric'>, any] 
  | ['reportMetric', string, number];

const useSls = () => {
  const loadSLsScript = () => {
    window.sls = window.sls || [];
    window.sls.push([
      'config',
      {
        urlHandler: () => {
          const { origin, pathname } = window.location;
          const current = window.__ENV__.TRANSACTION_GROUP_BY_URL.find((item) =>
            item.regex.test(pathname)
          );
          return `${origin}${current ? current.rewriteUrl : pathname}`;
        },
      },
    ]);
    const s: HTMLScriptElement = document.createElement('script');
    s.src = process.env.SLS_SDK!;
    s.async = true;
    s.id = 'sls-monitor';
    s.setAttribute('data-sls-host', process.env.SLS_HOST!);
    s.setAttribute('data-sls-project',  process.env.SLS_PROJECT!);
    s.setAttribute('data-sls-log-store',  process.env.SLS_LOGSTORE!);
    s.setAttribute(
      'data-sls-sampling-rate',
      process.env.ENV === 'prod' ? '0.1' : '1'
    );
    setTimeout(() => {
      document.body.appendChild(s);
    }, 2000);
  };

  // 自定义上报函数
  const reportSlsData = (slsData: Array<SlsData>) => {
    if (!window.sls || slsData.length == 0) return
    // 文档地址：https://fe.djicorp.com/specifications/ops/performance/2-sdk.html
    
    const href = window.location.href;
    // 判断是否存在 setEnvironment
    const hasSetEnvironment = slsData.some(item => item[0] === 'setEnvironment');
    
    // 重新排序
    let reorderedData;

    if (hasSetEnvironment) {
      // 修改现有的 setEnvironment 数据，添加 href 参数
      // 修复 urlHandler 对url 聚合后 无法获取完整 url 的问题
      reorderedData = slsData.map(item => {
        if (item[0] === 'setEnvironment') {
          return ['setEnvironment', { href, ...item[1] }];
        }
        return item;
      });
    } else {
      // 如果没有 setEnvironment，则新增一个包含 href 的 setEnvironment
      reorderedData = [
        ['setEnvironment', { href }],
        ...slsData
      ];
    }

    // 确保 setEnvironment 始终在数组最前面
    reorderedData = [
      ...reorderedData.filter(item => item[0] === 'setEnvironment'),
      ...reorderedData.filter(item => item[0] !== 'setEnvironment')
    ];
    
    window.sls.push(...reorderedData)
  };

  // 初始化 sls 脚本
  useEffect(() => {
    const slsEle = document.querySelector('#sls-monitor');
    if(!slsEle) {
      loadSLsScript();
    }
  }, []);

  return {
    reportSlsData
  }
};

export default useSls;
